import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=0e1de133"
import script from "./UploadImageModal.vue?vue&type=script&lang=js"
export * from "./UploadImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1de133')) {
      api.createRecord('0e1de133', component.options)
    } else {
      api.reload('0e1de133', component.options)
    }
    module.hot.accept("./UploadImageModal.vue?vue&type=template&id=0e1de133", function () {
      api.rerender('0e1de133', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload-image/UploadImageModal.vue"
export default component.exports